<!--时间对标-->
<template>
  
  <div class="mytimeBenchmark">
        <div class="con">
             <div class="tree-left">
                <elUnitTree @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>
	         		</div>
              <div class="right-table">
                  <div class="Files-top">
                        <div class="ic-left">
                        <span>时间对标</span>
                        </div>
                        <div class="btns">
                             <el-button type="primary"  @click="downloadExcel" class="last-el-button">导出</el-button>
                        </div>
                  </div>
                   <div class="search-input-btn" style="width:100%">
                     <el-scrollbar style="height:100%;width: 100%;">
                       <div class="my-search-i">
                          <div class="input-small mr-20">
                          <span>应用类型组：</span>
                              <el-select v-model="apptypeValue" multiple collapse-tags placeholder="请选择" size='small'>
                                <el-option label='全选' value='全选' @click.native='selectAll'></el-option>
                                <el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                              </el-select>
                          </div>
                          <div class="input-small mr-20 myinput">
                            <span>周期：</span>
                              <el-select v-model="nowTimetype" placeholder="请选择" >
                              <el-option v-for="item in timestype" :key="item.en"	:label="item.ch"	:value="item.en"></el-option>
                              </el-select>
                            </div>
                          <div class="input-small mr-20">
                          <span>时间一：</span>
                              <el-date-picker v-model="firstTime" value-format="timestamp" type="date" 
                                placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker>
                          </div>
                          <div class="input-small">
                          <span>时间二：</span>
                              <el-date-picker v-model="secondTime" value-format="timestamp" type="date" 
                                placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker>
                          </div>
                            <el-button type="primary" plain @click="search" class="search-btn">查询</el-button>
                        </div>
                      </el-scrollbar>
                    </div>
                    <div class="mychart" style="width:100%;height:400px">
                       <vchart style="width:100%;height:100%" ref='vchart'></vchart>
                    </div>
                    <div class="mytable">
                        <el-table :data="tableList"  :height="heights" border>
                              <template slot="empty">
                                <span class="noData">
                                  <img src="@/assets/noData.png" alt="暂无数据">
                                  <span class="text">暂无数据</span>
                                </span>
                              </template>
                              <el-table-column label="序号" width="90" fixed align="center">
                                <template slot-scope="scope">
                                  <span>{{ scope.$index + 1 }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column fixed prop="0" label="变量名" width="180">
                              </el-table-column>
                              <el-table-column align="center" v-for='(item,index) in columns' :prop="item.key" :label="item.name" :key="index">
                              </el-table-column>
                            </el-table>
                    </div>
                     <div class="paging">
                       <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                          :current-page="currentPage" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
                          layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                      </div>
                    <div class="el-loading-mask" v-show="loading">
                          <div class="el-loading-spinner">
                            <svg viewBox="25 25 50 50" class="circular">
                              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                            </svg>
                          </div>
                   </div>


	         		</div>
        </div>
  </div>
</template>

<script type="text/javascript">

  import vchart from '@/components/module/chart/vchart.vue'
      import elUnitTree from '@/components/module/newTree/elDeviceTree.vue'
  export default {
    components: {
      vchart,
      elUnitTree
    },
    props: [],
    data () {
      return {
        loading:false,
        heights: document.getElementById('app').clientHeight-685,//屏幕高度 - 导航栏高度
        date1: undefined,
        nowApptypeGroups: [],
        nowTimetype: 'day',
        options: {},
        dataList: [], //临时存储查询到的数据
        nowIndex: 0,
        total: 0,
        currentPage: 1,
        currentSize: 15,
        weekList: ['星期一','星期二','星期三','星期四','星期五','星期六','星期日'],
        from2name: {},
        apptypeValue: [],
        firstTime: new Date().getTime()-24*60*60*1000,
        secondTime: new Date().getTime(),
        timestype: [{
						ch: '日',
						en: 'day'
					},
					{
						ch: '周',
						en: 'week'
					},
					{
						ch: '月',
						en: 'month'
					},
					{
						ch: '季',
						en: 'quarter'
					},
					{
						ch: '年',
						en: 'year'
					}
				],
        nowVirtualDevice:{},
        pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
      }
    },
    created () {
      //默认从昨天开始查
      this.date1=new Date(this.date2.getTime()-24*60*60*1000)
      // setTimeout(() => {
      //   this.apptypeValue=['全选'];
      //   this.selectAll();
      // },1500)
    },
    mounted () {
      this.apptypeValue=this.nowSelectAppTypeGroupIds
      debugPage=this
      //初始化图表
      this.options=this.$refs.vchart.getDefaultOptions()
      this.options.tooltip.formatter=(params,ticket,callback) => {
        var h=params[0].data[0]
        var label=''
        params.forEach(item => {
          var values;
          if(isnull(item.data[1])) {
            values="无采集数据";
          } else {
            values=cutDigital(item.data[1]);
          }
          label+=item.seriesName+" : "+values+"</br>"
        })
        return label;
      },
        this.options.xAxis={
          type: 'category',
          splitLine: {
            show: false,
            lineStyle: {
              width: .5,
              type: 'solid'
            }
          },
        },
        this.options.yAxis={
          lineStyle: {
            show: false,
            width: 1,
            type: 'solid',
          }
        }
        this.options.toolbox={
          show: true,
          showTitle: true, // 隐藏默认文字，否则两者位置会重叠
          top: '-5',
          right: "20",
          feature: {
            magicType: {
              type: ['line','bar','stack','tiled'],title: {
                line: '切换为折线图',
                bar: '切换为柱状图',
                stack: '切换为堆叠',
                tiled: '切换为平铺',
              }
            },

            saveAsImage: {
              show: true,
              title: '下载图片'
            },
            // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
          },


        },
       
        this.$refs.vchart.setData(this.options,true)
      this.search()
      
    },
    destroyed () {},
    computed: {
      nowSelectAppTypeGroupIds () {
        return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      cacheStore () {
        return this.$store.cacheStore
      },
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
      datePickerType () {
        switch(this.nowTimetype) {
          case 'day':
          case 'week':
            return 'day'
          case 'month':
          case 'quarter':
            return 'month'
          case 'year':
            return 'year'
        }
      },
      apptypeGroups () {
        //所有已选中的设备所具有的变量类型组
        var list=[]
        var apptypeGroupIds=[]
        this.variableTree.forEach(apptypeGroup => {
          if(!apptypeGroupIds.includes(apptypeGroup.id)) {
            apptypeGroupIds.push(apptypeGroup.id)
            list.push(apptypeGroup)
          }
        })

         list.sort((a,b) => {
          return a.serialnum-b.serialnum
        })

        if(list.length != 0 && this.apptypeValue.length == 0){
        this.apptypeValue  = [list[0].id]
       }
        return list

      },
      date2 () {
        return this.cacheStore.getters.getNowSelectDate
      },
      variableTree () {
        console.log("ceshiunbakjsf ajkhbfkajthis.nowVirtualDevice",this.nowVirtualDevice);
        if(this.nowVirtualDevice==undefined) {
          return []
        }
        return this.$store.variableStore.getters.getVariableTree(this.nowVirtualDevice.no)
      },
      columns () {
        /*{
          name: '变量名'
        }*/
        var list=[]
        switch(this.nowTimetype) {
          case 'day':
            //取出每个整点值
            for(var i=0;i<24;i++) {
              list.push({
                name: (i<10? '0':'')+i+":00",
                key: String(i+1)
              })
            }
            break
          case 'week':
            for(var i=0;i<7;i++) {
              list.push({
                name: this.weekList[i],
                key: String(i+1)
              })
            }
            break
          case 'month':
            for(var i=1;i<=31;i++) {
              list.push({
                name: i+"日",
                key: String(i+1)
              })
            }
            break
          case 'quarter':
            for(var i=0;i<3;i++) {
              list.push({
                name: this.mergeQuarterList[i],
                key: String(i+1)
              })
            }
            break
          case 'year':
            for(var i=1;i<=12;i++) {
              list.push({
                name: i+"月",
                key: String(i+1)
              })
            }
            break
        }
        return list
      },
      nowVariableNames () {
        //当前应该显示的变量fromname列表
        var ag=this.nowApptypeGroups.map(item => {
          return item.id
        })
        var v1=this.variableTree.filter(item => {
          return ag.includes(item.id)
        })
        if(isempty(v1)) {
          return []
        }
        var v2=[]
        v1.forEach(item => {
          item.next.forEach(i => {

            v2.push(i.fromName) //name != fromName
          })
        })
        return v2
      },
      allVariableName () {
        //所有的通讯变量名称
        var list=[]
        for(var i=0,len=this.variableTree.length;i<len;i++) {
          var next=this.variableTree[i].next
          for(var i2=0,len2=next.length;i2<len2;i2++) {
            var item=next[i2]
            this.from2name[item.fromName]=item.name
            list.push(item.fromName) //fromName
          }
        }
        return list
      },
      fiflterDataList () {
        //经过过滤的应该显示的数据列表,未合并的
        if(this.dataList.length!=2) {
          return []
        }
        if(isempty(this.dataList[0])||isempty(this.dataList[1])) {
          return []
        }
        var list=[{},{}]
        this.nowVariableNames.forEach(item => {
          list[0][item]=this.dataList[0][item]
          list[1][item]=this.dataList[1][item]
        })
        return list
      },
      mergeDataList () {
        //用于渲染的合并后的数组
        if(isempty(this.fiflterDataList)||this.fiflterDataList.length!=2) {
          return []
        }
        //合并后的数据列，一个方便解析的数组
        var list1=this.tranList(this.fiflterDataList[0])
        var list2=this.tranList(this.fiflterDataList[1])
        //两个数组交叉合并,并且加上序号
        var list=[]
        for(var i=0;i<list1.length;i++) {
          //list1[i][0] = list1[i][0] + "-" + this.date1.formatByDate()
          list1[i][0]=list1[i][0]+"-"+new Date(this.firstTime).formatByDate()
          list.push(list1[i])
          list2[i][0]=list2[i][0]+"-"+new Date(this.secondTime).formatByDate()
          //list2[i][0] = list2[i][0] + "-" + this.date2.formatByDate()
          list.push(list2[i])
        }
        return list
      },
      chartDataList () {
        //图表使用的数据
        var list=[]
        for(var i=0,len=this.mergeDataList.length;i<len;i++) {
          var l=this.mergeDataList[i]
          var l2=[l[0]]
          switch(this.nowTimetype) {
            case 'day':
              //取出每个整点值
              for(var i2=1,len2=25;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([i2-1,value])
              }
              break
            case 'week':
              for(var i2=1,len2=8;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([this.weekList[i2-1],value])
              }
              break
            case 'month':
              for(var i2=1,len2=32;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([(i2)+'日',value])
              }
              break
            case 'quarter':
              for(var i2=1,len2=4;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([this.mergeQuarterList[i2-1],value])
              }
              break
            case 'year':
              for(var i2=1,len2=13;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([(i2)+'月',value])
              }
              break
          }

          list.push(l2)
        }
        return list
      },
      pageLen () {
        return this.mergeDataList.length < this.currentSize ? this.dataList.length:this.currentSize
      },
      nowPage () {
        this.total =   this.mergeDataList.length
        return this.mergeDataList.filter((item,index) => {
          return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
        })
      },
      tableList () {
         this.total =   this.mergeDataList.length
        let list=this.mergeDataList.filter((item,index) => {
          return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
        })
        let list2=[]
        if(!isempty(list)) {
          list.forEach(item => {
            let obj={}
            item.forEach((item2,index) => {
              obj[index]=item2
            })
            list2.push(obj)
          })
        }
        return list2
      },
      getDateText () {
        return date => {
          switch(this.nowTimetype) {
            case 'day':
              return date.formatByDate('-')
            case 'week':
              return date.formatByDate('-')
            case 'month':
              return date.formatByMonth('-')
            case 'quarter':
              return date.formatByMonth('-')
            case 'year':
              return date.getFullYear()+''
          }
        }
      },
      mergeQuarterList () {
        //混合坐标轴
        /* if((this.date1.getMonth() / 3 | 0) == (this.date2.getMonth() / 3 | 0)) {
          //同一个季度
          return this.getQuarterList(this.date1)
        } else {
          var list1 = this.getQuarterList(this.date1)
          var list2 = this.getQuarterList(this.date2) */
        if((new Date(this.firstTime).getMonth()/3|0)==(this.date2.getMonth()/3|0)) {
          //同一个季度
          return this.getQuarterList(new Date(this.firstTime))
        } else {
          var list1=this.getQuarterList(new Date(this.firstTime))
          var list2=this.getQuarterList(new Date(this.secondTime))
          var list=[]
          for(var i=0;i<3;i++) {
            list.push(list1[i]+"/"+list2[i])
          }
          return list
        }
      },
      // nowVirtualDevice () {
      //   console.log("this.$store.deviceStore.state.nowVirtualDevice",this.$store.deviceStore.state.nowVirtualDevice);
      //   return this.$store.deviceStore.state.nowVirtualDevice
      // }
    },
    watch: {
      allVariableName (nv,ov) {
        this.search()
      },
      chartDataList (nv,ov) {
        //重新渲染
        this.reloadChart(nv)
      },
      nowTimetype (nv,ov) {
        this.search()
      },
      firstTime () {
        this.search()
      },
      secondTime () {
        this.search()
      },
      /* date1(nv, ov) {
        this.search()
      },
      date2(nv, ov) {
        this.search()
      }, */
      apptypeValue (nv,ov) {
        this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',nv)
        let list=[]
        if(!isempty(nv)) {
          nv.forEach(item => {
            this.apptypeGroups.forEach(item2 => {
              if(item==item2.id) {
                list.push(item2)
              }
            })
          })
        }
        this.nowApptypeGroups=list
      }
    },
    methods: {
      checkFun(val){
        this.nowVirtualDevice = val[0]

      },
      downloadExcel () {
        let title='<thead><tr>'
        title+='<th colspan=6>'+new Date().formatByTime('-')+' 时间对标'+'</th>'
        title+='</tr></thead>'
        let aa=document.getElementsByTagName('thead')[0];//头部表达
        let bb=document.getElementsByTagName('tbody')[0];//列表内容
        let table=title+aa.innerHTML+bb.innerHTML
        exportToExcel(table,"时间对标报告")
      },
      selectAll () {

        //全选 先判断是否有选中的，有选中就清空
        if(this.apptypeValue.length==1) {
          this.nowApptypeGroup=this.apptypeGroups
          let idList=[]
          this.apptypeGroups.forEach(item => {
            idList.push(item.id)
          })
          this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',idList)
          this.apptypeValue=idList
        } else {
          this.nowApptypeGroup=[]
          this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',[])
          this.apptypeValue=[]
        }
      },
      clickChange (index) {
        this.nowIndex=index-1
      },
      prevClick () {
        if(this.nowIndex==1) {
          this.$message('当前为第一页');
          return
        }
        this.nowIndex-=1
      },
      nextClick () {
        if(this.nowIndex==Math.ceil(this.mergeDataList.length/this.pageLen)) {
          this.$message('当前为最后一页');
          return
        }
        this.nowIndex+=1
      },
      autoSelectMethod (item,index) {
        if(this.nowVirtualDevice!=undefined) {
          return this.nowVirtualDevice.id==item.id&&this.nowVirtualDevice.type==item.type
        } else {
          return item.type=='virtualDevice'
        }
      },
      search () {
        this.dataList=[]
        this.loading = true
        this.$api.historyApi.searchVariableHistoryWithDateType(this.allVariableName.join(','),this.nowTimetype,this.firstTime,
          respon => {
            this.$set(this.dataList,0,respon)
            this.loading =false
          })
        this.$api.historyApi.searchVariableHistoryWithDateType(this.allVariableName.join(','),this.nowTimetype,this.secondTime,
          respon => {
            this.$set(this.dataList,1,respon)
            this.loading =false
          })
      },
      tranList (dataObject) {
        //取出数据中的有效数据组织为数组
        var list=[]
        var keys=Object.keys(dataObject)
        for(var i=0,len=keys.length;i<len;i++) {
          var key=keys[i]
          var dataList=dataObject[key]
          if(!isempty(dataList)) {
            switch(this.nowTimetype) {
              case 'day':
                //取出每个整点值
                list.push(this.tranDayList(key,dataList[0]))
                break
              case 'week':
                list.push(this.tranWeekList(key,dataList))
                break
              case 'month':
                list.push(this.tranMonthList(key,dataList[0]))
                break
              case 'quarter':
                list.push(this.tranQuarterList(key,dataList))
                break
              case 'year':
                list.push(this.tranYearList(key,dataList))
                break
            }
          }
        }
        return list
      },
      getAvg (data) {
        //计算出合理值
        if(!isnull(data.avg)) {
          return data.avg
        }
        if(!isempty(data.data)) {
          var count=0
          var sum=data.data.reduce((a,b) => {
            if(isnull(b)) {
              return a
            }
            count++
            return a+b
          })
          if(count!=0) {
            return cutDigital(sum/count)
          }
        }
        return undefined
      },
      tranDayList (key,item) {
        //每天的数据，取整点值
        var name=this.from2name[key]? this.from2name[key]:key
        var list=[name.subByFirstChar('.')]
        if(isempty(item.data)) {
          return list
        }
        for(var i=0,len=item.data.length;i<len;i+=12) {
          var temp=item.data[i]
          if(isNaN(parseFloat((temp)))||isnull(parseFloat((temp)))) {
            temp=undefined
          }
          list.push(temp)
        }
        return list
      },
      tranWeekList (key,dataList) {
        //每周的数据，取平均值
        // var list = [key.subByFirstChar('.')]
        var name=this.from2name[key]? this.from2name[key]:key
        var list=[name.subByFirstChar('.')]
        for(var i=0;i<dataList.length;i++) {
          list.push(this.getAvg(dataList[i]))
        }
        return list
      },
      tranMonthList (key,item) {
        //每周的数据，取平均值
        // var list = [key.subByFirstChar('.')]
        var name=this.from2name[key]? this.from2name[key]:key
        var list=[name.subByFirstChar('.')]
        if(!isempty(item.data)) {
          var res=item.data.map(i => {
            if(isNaN(parseFloat((i)))||isnull(parseFloat((i)))) {
              return undefined
            } else {
              return i
            }
          })
          list.addAll(res)
        }
        return list
      },
      tranQuarterList (key,dataList) {
        //每周的数据，取平均值
        var name=this.from2name[key]? this.from2name[key]:key
        var list=[name.subByFirstChar('.')]
        for(var i=0;i<dataList.length;i++) {
          list.push(this.getAvg(dataList[i]))
        }
        return list
      },
      tranYearList (key,dataList) {
        //每周的数据，取平均值
        var name=this.from2name[key]? this.from2name[key]:key
        var list=[name.subByFirstChar('.')]
        for(var i=0;i<dataList.length;i++) {
          list.push(this.getAvg(dataList[i]))
        }
        return list
      },
      reloadChart (list) {
        var selected={}
        var legend=[]
        var seriesList=[]
        for(var i=0,len=list.length;i<len;i++) {
          var item=list[i]
          var name=item.shift()
          seriesList.push({
            name: name,
            type: 'line',
            smooth: true,
            symbol: 'emptyCircle',
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            sampling: 'average',
            data: item,
          })
          selected[name]=i<12? true:false
          legend.push({
            name: name,
            icon: 'roundRect'
          })
        }
        this.options.series=seriesList
        this.options.legend.data=legend
        this.options.legend.selected=selected
        
        // this.options.title.text=this.nowVirtualDevice.label+"-时间对标曲线"
        this.options.title.text=""
        this.$refs.vchart.setData(this.options,true)
      },
      getQuarterList (date) {
        switch(date.getMonth()/3|0) {
          case 0:
            return ['一月','二月','三月']
          case 1:
            return ['四月','五月','六月']
          case 2:
            return ['七月','八月','九月']
          case 3:
            return ['十月','十一月','十二月']
        }
      },
        //分页功能 
      handleSizeChange (val) {
        this.currentSize = val;
        // this.getList()
      },
      handleCurrentChange (val) {
        this.nowIndex = val - 1;
        // this.getList()
      }
    }
  }
</script>

<style scoped lang="scss">
   .mytimeBenchmark {
      .con{
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		display: flex;
      .search-input-btn {
    width: 100%;
    height: 36px;

    .my-search-i {
      width: 100%;
      display: flex;
      align-items: center;
    }
  }
   .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }
       .tree-left {
				width: 3rem;
				height: 100%;
				padding: 12px;
				box-sizing: border-box;
				background-color: #fff;
				margin-right: 8px;
				.btns {
					display: flex;
					// justify-content: space-evenly;
					margin-bottom: 8px;

					button {
					margin-right: 12px;
					}

					.el-button--mini {
					padding: 7px 10px !important;
					}

					.el-button+.el-button {
					margin-left: 0px;
					}
				}

				.search {
					display: flex;
					justify-content: center;
					margin-bottom: 12px;
				}

				}
	    .right-table {
          width: calc(100% - 3.08rem);
          height: 100%;
          padding: 12px 20px 20px 20px;
          box-sizing: border-box;
          background-color: #fff;
          position: relative;
		}
	}
   }
</style>